/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {GameMapsQuery, GameMapsQueryVariables} from '../types';

export const GameMapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GameMaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameMaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"originalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}}]}}]}}]} as unknown as DocumentNode;
/** hook для запроса "GameMaps" */
export function useGameMapsQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<GameMapsQuery, GameMapsQueryVariables>,
) {
    return ApolloReactHooks.useQuery<GameMapsQuery, GameMapsQueryVariables>(
        GameMapsDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<GameMapsQuery, GameMapsQueryVariables>),
    );
}
